<div class="tools-page" testId="tools-page-container">
  <header class="tools-header">
    <div>
      <p class="eyebrow">{{ 'tools.eyebrow' | i18n }}</p>
      <h1 testId="tools-title">{{ 'tools.title' | i18n }}</h1>
      <p class="subtitle">{{ 'tools.subtitle' | i18n }}</p>
    </div>
  </header>
  <nz-tabset class="tools-tabs" nzType="line" testId="tools-tabs">
    <nz-tab [nzTitle]="'tools.short-url.tab' | i18n" [testId]="'tools-short-url-tab'">
      <section class="tool-surface" testId="tools-short-url-surface">
        <div class="surface-heading">
          <div class="heading-icon"><span nz-icon nzType="link" nzTheme="outline"></span></div>
          <div>
            <h2 testId="tools-short-url-title">{{ 'tools.short-url.title' | i18n }}</h2>
            <p>{{ 'tools.short-url.description' | i18n }}</p>
          </div>
        </div>
        <form nz-form [formGroup]="urlForm" (ngSubmit)="generateShortUrl()" class="short-url-form" testId="tools-short-url-form">
          <nz-form-item>
            <nz-form-label nzRequired>{{ 'tools.short-url.long-url' | i18n }}</nz-form-label>
            <nz-form-control [nzErrorTip]="'tools.short-url.invalid-url' | i18n">
              <input
                nz-input
                formControlName="url"
                [placeholder]="'tools.short-url.placeholder' | i18n"
                autocomplete="url"
                testId="tools-short-url-input"
              />
            </nz-form-control>
          </nz-form-item>
          <button nz-button nzType="primary" [nzLoading]="generating" type="submit" testId="tools-short-url-generate-button">
            <span nz-icon nzType="thunderbolt" nzTheme="outline"></span>{{ 'tools.short-url.generate' | i18n }}
          </button>
        </form>
        <div class="result-panel" *ngIf="shortUrl" aria-live="polite" testId="tools-short-url-result">
          <div class="result-label">{{ 'tools.short-url.result' | i18n }}</div>
          <div class="result-row">
            <code testId="tools-short-url-code">{{ shortUrl }}</code>
            <button
              nz-button
              nzType="default"
              (click)="copyShortUrl()"
              [attr.aria-label]="'tools.short-url.copy' | i18n"
              testId="tools-short-url-copy-button"
            >
              <span nz-icon nzType="copy" nzTheme="outline"></span>{{ 'tools.short-url.copy' | i18n }}
            </button>
          </div>
        </div>
      </section>
    </nz-tab>
    <nz-tab [nzTitle]="'tools.coming-soon.tab' | i18n" [testId]="'tools-coming-soon-tab'">
      <section class="empty-surface" testId="tools-coming-soon-surface">
        <span nz-icon nzType="tool" nzTheme="outline"></span>
        <h2>{{ 'tools.coming-soon.title' | i18n }}</h2>
        <p>{{ 'tools.coming-soon.description' | i18n }}</p>
      </section>
    </nz-tab>
  </nz-tabset>
</div>
